import React from 'react';
import { CheckIcon, XIcon, AlertCircleIcon, SearchIcon, SlidersIcon } from 'lucide-react';
type Transaction = {
  id: string;
  date: string;
  description: string;
  amount: number;
  matched: boolean;
  confidence?: number;
};
type Receipt = {
  id: string;
  date: string;
  vendor: string;
  amount: number;
  matched: boolean;
  fileName: string;
};
export const AIAssistantPage = () => {
  const transactions: Transaction[] = [{
    id: '1',
    date: '2024-02-15',
    description: 'Amazon.de',
    amount: 49.99,
    matched: true,
    confidence: 98
  }, {
    id: '2',
    date: '2024-02-14',
    description: 'Tankstelle Shell',
    amount: 65.3,
    matched: true,
    confidence: 95
  }, {
    id: '3',
    date: '2024-02-14',
    description: 'Office Supply Store',
    amount: 129.99,
    matched: false
  }, {
    id: '4',
    date: '2024-02-13',
    description: 'Deutsche Bahn',
    amount: 89.9,
    matched: true,
    confidence: 96
  }, {
    id: '5',
    date: '2024-02-12',
    description: 'Media Markt',
    amount: 599.0,
    matched: true,
    confidence: 92
  }, {
    id: '6',
    date: '2024-02-12',
    description: 'Lidl Filiale',
    amount: 42.15,
    matched: false
  }, {
    id: '7',
    date: '2024-02-11',
    description: 'Adobe Creative Cloud',
    amount: 59.99,
    matched: true,
    confidence: 99
  }, {
    id: '8',
    date: '2024-02-10',
    description: 'Hotel Maritim',
    amount: 189.0,
    matched: false
  }];
  const receipts: Receipt[] = [{
    id: '1',
    date: '2024-02-15',
    vendor: 'Amazon',
    amount: 49.99,
    matched: true,
    fileName: 'amazon_invoice_123.pdf'
  }, {
    id: '2',
    date: '2024-02-14',
    vendor: 'Shell',
    amount: 65.3,
    matched: true,
    fileName: 'shell_receipt_456.pdf'
  }, {
    id: '3',
    date: '2024-02-14',
    vendor: 'Staples',
    amount: 129.99,
    matched: false,
    fileName: 'staples_invoice_789.pdf'
  }, {
    id: '4',
    date: '2024-02-13',
    vendor: 'Deutsche Bahn',
    amount: 89.9,
    matched: true,
    fileName: 'db_ticket_234.pdf'
  }, {
    id: '5',
    date: '2024-02-12',
    vendor: 'Media Markt',
    amount: 599.0,
    matched: true,
    fileName: 'mediamarkt_rechnung_567.pdf'
  }, {
    id: '6',
    date: '2024-02-12',
    vendor: 'Lidl',
    amount: 42.15,
    matched: false,
    fileName: 'lidl_bon_890.pdf'
  }, {
    id: '7',
    date: '2024-02-11',
    vendor: 'Adobe',
    amount: 59.99,
    matched: true,
    fileName: 'adobe_invoice_345.pdf'
  }, {
    id: '8',
    date: '2024-02-10',
    vendor: 'Hotel Maritim',
    amount: 189.0,
    matched: false,
    fileName: 'maritim_rechnung_678.pdf'
  }];
  return <div className="flex h-screen bg-gray-50" data-id="element-188">
      {/* Sidebar - reuse existing sidebar code */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-189">
        {/* Header */}
        <header className="bg-white border-b border-gray-200" data-id="element-190">
          <div className="flex items-center justify-between px-6 py-4" data-id="element-191">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-192">KI-Assistent</h1>
            <div className="flex items-center space-x-4" data-id="element-193">
              <div className="flex items-center space-x-2 bg-blue-50 text-blue-700 px-3 py-1 rounded-full" data-id="element-194">
                <span className="text-sm font-medium" data-id="element-195">KI-Score: 94%</span>
              </div>
            </div>
          </div>
        </header>
        {/* Main Content */}
        <main className="flex-1 overflow-auto p-6" data-id="element-196">
          {/* Filters */}
          <div className="flex justify-between items-center mb-6" data-id="element-197">
            <div className="flex space-x-4" data-id="element-198">
              <div className="relative" data-id="element-199">
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-200" />
                <input type="text" placeholder="Suchen..." className="pl-10 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-201" />
              </div>
              <button className="flex items-center space-x-2 px-4 py-2 border border-gray-200 rounded-md hover:bg-gray-50" data-id="element-202">
                <SlidersIcon className="h-5 w-5 text-gray-600" data-id="element-203" />
                <span data-id="element-204">Filter</span>
              </button>
            </div>
            <div className="flex items-center space-x-2" data-id="element-205">
              <span className="text-sm text-gray-600" data-id="element-206">Sortieren nach:</span>
              <select className="border border-gray-200 rounded-md px-3 py-2" data-id="element-207">
                <option data-id="element-208">Datum</option>
                <option data-id="element-209">Betrag</option>
                <option data-id="element-210">Konfidenz</option>
              </select>
            </div>
          </div>
          {/* Matching Interface */}
          <div className="grid grid-cols-2 gap-6" data-id="element-211">
            {/* Transactions */}
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-212">
              <h2 className="text-lg font-semibold mb-4" data-id="element-213">Banktransaktionen</h2>
              <div className="space-y-4" data-id="element-214">
                {transactions.map(transaction => <div key={transaction.id} className={`p-4 rounded-lg border ${transaction.matched ? 'border-green-100 bg-green-50' : 'border-gray-200 bg-gray-50'}`} data-id="element-215">
                    <div className="flex justify-between items-start mb-2" data-id="element-216">
                      <div data-id="element-217">
                        <p className="font-medium text-gray-900" data-id="element-218">
                          {transaction.description}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-219">
                          {new Date(transaction.date).toLocaleDateString('de-DE')}
                        </p>
                      </div>
                      <span className={`font-medium ${transaction.amount < 0 ? 'text-red-600' : 'text-green-600'}`} data-id="element-220">
                        {transaction.amount.toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR'
                    })}
                      </span>
                    </div>
                    {transaction.matched && <div className="flex items-center justify-between text-sm" data-id="element-221">
                        <div className="flex items-center space-x-1 text-green-600" data-id="element-222">
                          <CheckIcon className="h-4 w-4" data-id="element-223" />
                          <span data-id="element-224">Zugeordnet</span>
                        </div>
                        <span className="text-blue-600" data-id="element-225">
                          {transaction.confidence}% Konfidenz
                        </span>
                      </div>}
                  </div>)}
              </div>
            </div>
            {/* Receipts */}
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-226">
              <h2 className="text-lg font-semibold mb-4" data-id="element-227">Belege</h2>
              <div className="space-y-4" data-id="element-228">
                {receipts.map(receipt => <div key={receipt.id} className={`p-4 rounded-lg border ${receipt.matched ? 'border-green-100 bg-green-50' : 'border-gray-200 bg-gray-50'}`} data-id="element-229">
                    <div className="flex justify-between items-start mb-2" data-id="element-230">
                      <div data-id="element-231">
                        <p className="font-medium text-gray-900" data-id="element-232">
                          {receipt.vendor}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-233">
                          {new Date(receipt.date).toLocaleDateString('de-DE')}
                        </p>
                        <p className="text-sm text-gray-400" data-id="element-234">
                          {receipt.fileName}
                        </p>
                      </div>
                      <span className="font-medium text-gray-900" data-id="element-235">
                        {receipt.amount.toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR'
                    })}
                      </span>
                    </div>
                    {receipt.matched ? <div className="flex items-center justify-between" data-id="element-236">
                        <div className="flex items-center space-x-2" data-id="element-237">
                          <button className="text-green-600 hover:text-green-700" data-id="element-238">
                            <CheckIcon className="h-5 w-5" data-id="element-239" />
                          </button>
                          <button className="text-red-600 hover:text-red-700" data-id="element-240">
                            <XIcon className="h-5 w-5" data-id="element-241" />
                          </button>
                        </div>
                        <span className="text-sm text-green-600" data-id="element-242">
                          Zugeordnet
                        </span>
                      </div> : <div className="flex items-center space-x-1 text-yellow-600 text-sm" data-id="element-243">
                        <AlertCircleIcon className="h-4 w-4" data-id="element-244" />
                        <span data-id="element-245">Warte auf Zuordnung</span>
                      </div>}
                  </div>)}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
};